import script from "./FührerscheinKlassen.vue?vue&type=script&setup=true&lang=js"
export * from "./FührerscheinKlassen.vue?vue&type=script&setup=true&lang=js"

import "./FührerscheinKlassen.vue?vue&type=style&index=0&id=117ad837&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117ad837"]])

export default __exports__